import { defineComponent } from "vue";
import { Flow } from "@/interfaces/sdk-flow";
import { extractUrlParams, generateUrl } from "../form-utils";

export default defineComponent({
  name: "sdk-flow-task-form-params",
  props: {
    taskForm: String,
  },
  data() {
    return {
      requiredParams: {} as Flow.Task.Form.UrlParams,
      formName: "",
    };
  },
  methods: {
    extractFormKeyInfo(formKey: string) {
      /** Decompôe o formKey em três grupos, product, formUrl e formName */
      const reg = new RegExp(/(.*?):(.*)\((.*)\)/);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, product, formUrl, formName] = reg.exec(formKey) as RegExpExecArray;
      return { product, formUrl, formName };
    },
    async applyScreenOntask() {
      const { formUrl, product, formName } = await this.extractFormKeyInfo(this.taskForm || "");
      const fullUrl = generateUrl(formUrl, this.requiredParams);
      document.body.dispatchEvent(
        new CustomEvent("forms:selected", {
          bubbles: true,
          detail: {
            id: `${product}:${fullUrl}(${formName})`,
          },
        })
      );
      this.$emit("close");
    },
    clearForm() {
      document.body.dispatchEvent(
        new CustomEvent("forms:selected", {
          bubbles: true,
          detail: {
            id: "",
          },
        })
      );
      this.$emit("close");
    },
  },
  async mounted() {
    const { formUrl, formName } = this.extractFormKeyInfo(this.taskForm || "");
    this.formName = formName;
    this.requiredParams = await extractUrlParams(formUrl);
  },
});
